import React from "react";
import { Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { userData } from "../../utility/types/userTypes";
import CreateEventComponent from "../home-common-components/CreateEventComponent";
import MyEventsWalkthrough from "../walk-through-common-components/myEventTooltips/MyEventsWalkthrough";
type MyEventHeaderProps = {
  userData: userData;
  isMyEvents: boolean;
  setIsMyEvents: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEventTypeModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const MyEventHeader: React.FC<MyEventHeaderProps> = ({
  userData,
  isMyEvents,
  setIsMyEvents,
  setShowEventTypeModal,
}) => {
  const deviceSize = useDeviceSize();

  return (
    <>
      <View
        style={{
          marginBottom: 10,
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingHorizontal:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "3.5%"
              : 0,
        }}
      >
        <MyEventsWalkthrough
          content={
            <Text
              style={[
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? AppFontStyle.BOLD_ANYBODY_18
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  color: AppColors.white,
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                  minWidth: 101,
                },
              ]}
            >
              My events
            </Text>
          }
        />
        <CreateEventComponent
          isMyEvents={isMyEvents}
          setIsMyEvents={setIsMyEvents}
          setShowEventTypeModal={setShowEventTypeModal}
          userData={userData}
        />
      </View>
    </>
  );
};

export default MyEventHeader;
